import { Organisation } from '~organisations/domain';

import logo from './images/logo.png';

const vgaConfig: Organisation = {
  logo: logo,
  additionalOutcomeCaptureFields: {},
  asyncAdditionalOutcomeCaptureFields: {},
  contactAssessmentForms: {},
};

export default vgaConfig;
